import filesize from "filesize";
import React, { ReactElement, useState } from "react";
import { Button, ListGroup } from "react-bootstrap";
import Swal, { SweetAlertResult } from "sweetalert2";
import { Attachment } from "../attachments";
import { useProjects } from "../projects";
import { FileIcon, Loading } from "../ui";

interface IProps {
	attachments: Attachment[];
	folder: string;
	appendAttachableId?: boolean;
}

export const AttachmentsListGroup = (props: IProps): ReactElement => {
	const projectContext = useProjects();

	const [modalIsOpen, setModalState] = useState(false);
	const [_, setSelectedImageIndex] = useState<number>();

	const toggleModal = (selectedIndex?: number) => {
		setModalState(!modalIsOpen);
		if (selectedIndex) {
			setSelectedImageIndex(selectedIndex);
		}
	};

	const handleDeleteFile = (
		event: React.MouseEvent<HTMLButtonElement>,
		file: Attachment,
	) => {
		event.stopPropagation();
		Swal.fire({
			title: "Are you sure?",
			text: `${file.filename} cannot be restored once deleted.`,
			icon: "warning",
			confirmButtonText: "Yes, delete it!",
			showCancelButton: true,
		}).then((result: SweetAlertResult) => {
			if (result.value) {
				projectContext.deleteFile!(file);
			}
		});
	};

	if (!projectContext.project) {
		return <Loading />;
	}

	const images: any = [];
	const AttachmentItems = props.attachments.map((attachment, index) => {
		const filename = attachment.filename;
		const ext = filename.substr(filename.lastIndexOf(".") + 1);
		let folder = props.folder;

		if (props.appendAttachableId) {
			folder = `${folder}/${attachment.attachableId}/`;
		}

		if (attachment.isImage()) {
			images.push({
				src: `/download?file=${encodeURIComponent(
					filename,
				)}&folder=${folder}&download=false`,
			});
		}

		const imgIndex = images.length - 1;

		return (
			<ListGroup.Item
				key={index}
				className="file-item"
				onClick={() => {
					if (attachment.isImage()) {
						toggleModal(imgIndex);
					}
				}}
			>
				<FileIcon extension={ext} />
				<a
					target="_blank"
					href={`/download?file=${encodeURI(
						encodeURIComponent(filename),
					)}&folder=${props.folder}`}
					style={{ paddingLeft: 10 }}
				>
					{filename}
				</a>{" "}
				<Button
					className="delete-file-button"
					variant="light"
					size="sm"
					onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
						handleDeleteFile(event, attachment)
					}
				>
					Delete
				</Button>
				<span className="float-right">
					( {filesize(attachment.fileSize)} )
				</span>
			</ListGroup.Item>
		);
	});

	return (
		<>
			<ListGroup variant="flush" className="attachment-list-group">
				<ListGroup.Item>
					<strong>Files</strong>
				</ListGroup.Item>
				{AttachmentItems}
			</ListGroup>
		</>
	);
};
